export default "__VITE_ASSET__CpFYofyg__";